import { twMerge } from "tailwind-merge";

export function SmallPreamble({
  children,
  elementType,
  className,
}: {
  children: React.ReactNode;
  elementType: "p" | "dd" | "li";
  className?: string;
}) {
  const Element = elementType;

  return (
    <Element
      className={twMerge("text-base leading-7 text-gray-600", className)}
    >
      {children}
    </Element>
  );
}
